/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Article_Discord_Bot_TitleInputs */



/**
* | output |
* | --- |
* | "Discord Bot" |
*
* @param {Help_Article_Discord_Bot_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const help_article_discord_bot_title = /** @type {((inputs?: Help_Article_Discord_Bot_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Article_Discord_Bot_TitleInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Discord-Bot")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Bot Discord")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("Discord 机器人")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("Discord 機器人")
	if (locale === "ko") return /** @type {LocalizedString} */ ("Discord 봇")
	return /** @type {LocalizedString} */ ("Discord Bot")
});